
import crossFetch from 'cross-fetch';
import { 
  ResponseError 
} from '@backstage/errors';;

import {
  DiscoveryApi,
  FetchApi,
} from './types';
import { 
  EpDevPPluginIds 
} from '../constants';

/**
 * Common api client base class for other plugins to extend.
 */
export class EpDevPApiClientBase {
  private readonly discoveryApi: DiscoveryApi;
  protected readonly fetchApi: FetchApi;
  private readonly pluginId: EpDevPPluginIds;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
    pluginId: EpDevPPluginIds;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };    
    this.pluginId = options.pluginId;
  }

  protected async createUrl(path: string): Promise<string> {
    return `${await this.discoveryApi.getBaseUrl(this.pluginId)}${path}`;
  }

  protected async request({ method, url, body, bearerToken }: {
    method: string;
    url: string;
    body?: BodyInit | null;
    bearerToken?: string;
  }): Promise<any> {
    const funcName = 'requestRequired';
    // const logName = `${EpDevPApiRequest.name}.${funcName}()`;
    const headers: any = {};
    if(body) headers['Content-Type'] = 'application/json';
    if(bearerToken) headers['Authorization'] = `Bearer ${bearerToken}`;

    const response = await this.fetchApi.fetch(url, { 
      method: method,
      headers: headers,
      body: body
    });
    console.log(`\n\n${funcName} - received response\n\n`);

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    // could be: 
    // - empty response body
    // - json 
    // - blob
    // if(response.headers.get('Content-Type') === 'application/zip') return await response.blob();
    // return await response.json();


    try {
      if(response.headers.get('Content-Type') === 'application/zip') return await response.blob();
      const json = await response.json();
      return json;
    } catch(e) {
      // empty response
      // console.log(`\n\n${logName} - not a json, returning void\n\n`);
    }
    return;
  }


}
